import { z } from "zod";

import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";
import { SnackSettingsInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { domainNameZodSchema, gtmIDZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const snackSettingsInputZodSchema = SnackSettingsInputSchema.extend({
	subDomain: domainNameZodSchema,
	baseDomain: z.string(),
	gtmID: gtmIDZodSchema,
	// スナックの公開状態（検索に表示しないかどうか）。公開設定（guestPageVisibilitySettings）として一緒に保存する
	guestPageVisibility: z.nativeEnum(GuestPageVisibilityMode),
});

export type SnackSettingsZodSchemaType = z.infer<typeof snackSettingsInputZodSchema>;
